import tw from "twin.macro";

export const size38 = tw`p-2 text-lg leading-5`;
export const size40 = tw`py-2 px-6 text-sm`;
export const size66 = tw`py-3 px-6 text-2xl 2xl:py-4 2xl:px-8 2xl:text-2xl`;
